import React, {Component} from 'react';
import {VendorService} from '../services/VendorService';
import {FilterMatchMode, FilterOperator} from 'primereact/api';
import {Button} from 'primereact/button';
import {Column} from 'primereact/column';
import {DataTable} from 'primereact/datatable';
import {Toast} from 'primereact/toast';
import {ProgressBar} from 'primereact/progressbar';
import {Toolbar} from 'primereact/toolbar';
import {TreeSelect} from 'primereact/treeselect';
import {Chip} from 'primereact/chip';
import {InputText} from 'primereact/inputtext';
import {Dropdown} from 'primereact/dropdown';
import {Badge} from 'primereact/badge';
import { Panel } from 'primereact/panel';
import { Tooltip } from 'primereact/tooltip';
import '../custom.css';

export class ApprovedVendors extends Component {
    static displayName = ApprovedVendors.name;

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            filters: {
                'VendorName': {operator: FilterOperator.AND, constraints: [{value: null, matchMode: FilterMatchMode.CONTAINS }] }
            },
            expandedRows: null,
            vendors: [],
            filteredVendors: [],
            categories: [],
            selectedCategories: [],
            locations: [],
            selectedLocations: [],
            selectedRows: [],
            searchOption: null,
            searchName: "",
            searchSentenceText: ""
        };

        this.vendorService = new VendorService();
        this.exportCSV = this.exportCSV.bind(this);
    }

    async componentDidMount() {
        const categories = await this.vendorService.getVendorCategoryData();
        const locations = await this.vendorService.getVendorLocationData();
        const vendors = await this.vendorService.getApprovedVendorsData();

        this.setState({loading: false, categories, locations, vendors });
    }

    isNullOrWhiteSpace = (value) => {
        return value === null || value === undefined || value.trim() === '';
    }

    dtHeader() {
        const searchOptions = [
            { label: "Name of Vendor", value: "Name of Vendor" },
            { label: "Category and Location", value: "Category and Location" },
            { label: "Download All Vendor Export File", value: "Download" }
            ];

        const panelColors = {
            backgroundColor: "white",
            step1: "#60a2d7",
            step2: "#60a2d7",
            step3: "#60a2d7"
        };

        const panelText = {
            step1: <span><span style={{ color: panelColors.step1 }}>How </span>do you want to search for a vendor?</span>,
            step2: <span>What <span style={{ color: panelColors.step2 }}>type</span> of vendor were you looking for?</span>,
            step2name: <span>What is the <span style={{ color: panelColors.step2 }}>name</span> of the vendor were you looking for?</span>,
            step3: <span>What <span style={{ color: panelColors.step3 }}>location</span> are you interested in for vendor services?</span>,
            search: <span>Click <span style={{ color: panelColors.step3 }}>Search</span> to see your results!</span>,
            download: <span>Click <span style={{ color: panelColors.step2 }}>Export All Vendors</span> to download the complete approved vendor list!</span>
        };

        const header = (num, text, color) => (
            <div style={{ backgroundColor: panelColors.backgroundColor, display: 'flex', flexDirection: 'column', minHeight: "90px" }}>
                <Badge style={{ alignSelf: 'center', backgroundColor: color, marginBottom: '20px' }} value={num} size="large"></Badge>
                <p style={{ textAlign:"center", margin: "0" }}>{text}</p>
            </div>
        );

        const leftContents = (
            <div className="left-contents-style grid">
                <Panel className="col-3" style={{ margin: '0', maxWidth: '300px' }} header={header(1, panelText.step1, panelColors.step1)}>
                    <Dropdown className='toolbar-dropdown' style={{ minWidth: '100%', maxWidth: '100%' }} value={this.state.searchOption} options={searchOptions} onChange={(e) => this.setState({ searchOption: e.value })} placeholder="Select Search Type" disabled={this.state.loading} />
                </Panel>
                {this.state.searchOption === "Download" && (
                    <>
                        <Panel className="col-3" style={{ margin: '0', maxWidth: '300px' }} header={header(2, panelText.download, panelColors.step2)}>
                            <Button className="toolbar-button button-fixed-width p-button-content" style={{ minWidth: '100%', maxWidth: '100%' }} type="button" icon="pi pi-file-excel" label="Export All Vendors" onClick={() => this.exportCSV()} data-pr-tooltip="XLS" disabled={this.state.loading} />
                        </Panel>
                    </>
                )}
                {this.state.searchOption === "Name of Vendor" && (
                    <>
                        <Panel className="col-3" style={{ margin: '0', maxWidth: '300px' }} header={header(2, panelText.step2name, panelColors.step2)}>
                            <InputText className='toolbar-button' style={{ minWidth: '100%', maxWidth: '100%' }} value={this.state.searchName} onChange={(e) => this.setState({ searchName: e.target.value })} placeholder="Search by Name" disabled={this.state.loading} />
                        </Panel>
                        <Panel className="col-3" style={{ margin: '0', maxWidth: '300px' }} header={header(3, panelText.search, panelColors.step3)}>
                            <Button className='toolbar-button button-fixed-width p-button-content' style={{ minWidth: '100%', maxWidth: '100%' }} label="Search" icon="pi pi-search" onClick={() => this.filterVendors()} disabled={this.state.loading} />
                        </Panel>
                    </>
                )}
                {this.state.searchOption === "Category and Location" && (
                    <>
                        <Panel className="col-3" style={{ margin: '0', maxWidth: '300px' }} header={header(2, panelText.step2, panelColors.step2)}>
                            <TreeSelect className='toolbar-button' style={{ minWidth: '100%', maxWidth: '100%' }} value={this.state.selectedCategories} options={this.state.categories} onChange={(e) => this.setState({ selectedCategories: e.value })} selectionMode="checkbox" placeholder="Select Categories" disabled={this.state.loading} />
                        </Panel>
                        <Panel className="col-3" style={{ margin: '0', maxWidth: '300px' }} header={header(3, panelText.step3, panelColors.step3)}>
                            <TreeSelect className='toolbar-button' style={{ minWidth: '100%', maxWidth: '100%' }} value={this.state.selectedLocations} options={this.state.locations.filter(x => x.label !== "KIPP Texas")} onChange={(e) => this.setState({ selectedLocations: e.value })} selectionMode="checkbox" placeholder="Select Locations" disabled={this.state.loading} />
                        </Panel>
                        <Panel className="col-3" style={{ margin: '0', maxWidth: '300px' }} header={header(4, panelText.search, panelColors.step3)}>
                            <Button className='toolbar-button button-fixed-width p-button-content' style={{ minWidth: '100%', maxWidth: '100%' }} label="Search" icon="pi pi-search" onClick={() => this.filterVendors()} disabled={this.state.loading} />
                        </Panel>
                    </>
                )}
            </div>
        );

        const rightContents = (
            <div className="right-contents-style">
            </div>
        );

        return (
            <React.Fragment>
                <Toolbar className="toolbar-style" left={leftContents} right={rightContents} />
                <div style={{textAlign:"center"}}>{this.state.searchSentenceText}</div>
            </React.Fragment>
        );
    }



    flatten = (data) => {
        return data.flatMap(parent => {
            const flattenedParent = {
                ...parent,
                children: [] // empty child array to stop recursion
            };

            const flattenedChildren = parent.children.map(child => ({
                ...child,
                color: parent.color,
                textColor: parent.textColor,
                data: parent.data + " - " + child.data
            }));

            return [flattenedParent, ...flattenedChildren];
        });
    }

    getSelectedLocations = () => {
        const selectedLocationKeys = Object.keys(this.state.selectedLocations).filter(key => { return this.state.selectedLocations[key].checked; });
        const flatLocations = this.flatten(this.state.locations);
        const selectedLocations = flatLocations.filter(l => selectedLocationKeys.includes(l.key)).flatMap(l => l.data.split(',').map(item => item.trim()));
        return selectedLocations;
    }

    getSelectedCategories = () => {
        const selectedCategoryKeys = Object.keys(this.state.selectedCategories).filter(key => { return this.state.selectedCategories[key].checked; });
        const flatCategories = this.flatten(this.state.categories);
        const selectedCategories = flatCategories.filter((c) => { return selectedCategoryKeys.includes(c.key); }).map((c) => { return c.data; });
        return selectedCategories;
    }

    filterVendors = async () => {
        let filteredVendors = [...this.state.vendors]; // Start with all vendors
        let searchSentenceText = "Showing 0 vendors who meet the criteria selected above.";

        // Filter by name if the search option is 'Name of Vendor'
        if (this.state.searchOption === "Name of Vendor" && this.state.searchName.trim() !== "") {
            filteredVendors = filteredVendors.filter(vendor =>
                vendor.VendorName.toLowerCase().includes(this.state.searchName.trim().toLowerCase())
            );
        }

        // Filter by locations & categories
        if (this.state.searchOption === "Category and Location") {

            // Filter by categories
            const selectedCategories = this.getSelectedCategories();
            if (selectedCategories.length > 0) {
                filteredVendors = filteredVendors.filter(vendor =>
                    selectedCategories.some(value =>
                        vendor.Category1 === value ||
                        vendor.Category2 === value ||
                        vendor.Category3 === value ||
                        vendor.Category4 === value ||
                        vendor.Category5 === value
                    )
                );
            }

            // FIlter by locations
            const selectedLocations = this.getSelectedLocations();
            if (selectedLocations.length > 0) {
                filteredVendors = filteredVendors.filter(vendor =>
                    selectedLocations.some(value => vendor.ApprovedRegions ? vendor.ApprovedRegions.includes(value) : false)
                );
            }
        }

        searchSentenceText = `Showing ${filteredVendors.length} vendors who meet the criteria selected above.`;

        this.setState({ loading: false, filteredVendors: filteredVendors, searchSentenceText: searchSentenceText });
    }

    async exportCSV() {
        await this.vendorService.downloadApprovedVendorsCSV();
    }

    vendorNameBodyTemplate = (rowData) => {
        if (this.isNullOrWhiteSpace(rowData.VendorPhone)) {
            return (<span>{rowData.VendorName}</span>);
        } else {
            return (<div><Tooltip target=".custom-target-icon" autoHide={false} /> {rowData.VendorName} <i className="custom-target-icon pi pi-phone" tooltip={rowData.VendorPhone} data-pr-tooltip={rowData.VendorPhone}></i></div>);
        }
        
    }

    regionBodyTemplate = (rowData) => {
        const locationData = rowData.ApprovedRegions ? rowData.ApprovedRegions.split(",").map(item => item.trim()) : [];
        const locationLabels = this.state.locations
            .filter(location => locationData.some(value => location.data.includes(value)))
            .map(location => location.label)
            .filter(x => x !== "KIPP Texas")
            .sort()
            .map(locationLabel => <Chip label={locationLabel} icon="pi pi-map-marker" style={{ margin: "2px" }} />);
        return (<span>{locationLabels}</span>);
    }

    categoryBodyTemplate = (rowData) => {
        const categories = [];
        if (rowData.Category1) {categories.push(rowData.Category1); }
        if (rowData.Category2) {categories.push(rowData.Category2); }
        if (rowData.Category3) {categories.push(rowData.Category3); }
        if (rowData.Category4) {categories.push(rowData.Category4); }
        if (rowData.Category5) {categories.push(rowData.Category5); }
        const categoryLabels = categories
            .sort()
            .map(categoryLabel => <Chip label={categoryLabel} icon="pi pi-tag" style={{ margin: "2px", backgroundColor: this.getCategoryBackgroundColor(categoryLabel), color: this.getCategoryColor(categoryLabel) }} />);
        return (<span>{categoryLabels}</span>);
    }

    getCategoryBackgroundColor = (categoryData) => {
        const flatCategories = this.flatten(this.state.categories);
        const matchingCategories = flatCategories.filter(category => category.data === categoryData);

        if (matchingCategories && matchingCategories.length > 0) {
            return matchingCategories[0].color;
        } else {
            // try to match on just parent so the colors are still correct
            const parentCategoryData = categoryData.split("-").map(function (item) { return item.trim(); })[0];
            const parentMatchingCategories = flatCategories.filter(category => category.data === parentCategoryData);
            if (parentMatchingCategories && parentMatchingCategories.length > 0) {
                return parentMatchingCategories[0].color;
            } else {
                return null;
            }
        }
    }

    getCategoryColor = (categoryData) => {
        const flatCategories = this.flatten(this.state.categories);
        const matchingCategories = flatCategories.filter(category => category.data === categoryData);

        if (matchingCategories && matchingCategories.length > 0) {
            return matchingCategories[0].textColor ?? "revert";
        } else {
            // try to match on just parent so the colors are still correct
            const parentCategoryData = categoryData.split("-").map(function (item) { return item.trim(); })[0];
            const parentMatchingCategories = flatCategories.filter(category => category.data === parentCategoryData);
            if (parentMatchingCategories && parentMatchingCategories.length > 0) {
                return parentMatchingCategories[0].textColor;
            } else {
                return "revert";
            }
        }
    }

    render() {
        const header = this.dtHeader();

        return (
        <div>
            {this.state.loading ? <ProgressBar mode="indeterminate" style={{ height: '4px' }} /> : ''}
            <div className="row" >
                <div className="p-col-12" >
                    <Toast ref={(el) => this.toast = el} />
                    <Tooltip target=".custom-target-icon" autoHide={false} />
                    <div style={{ height: 'calc(100vh - 60px)' }}>
                        <DataTable
                            ref={(el) => { this.dt = el; }}
                            value={this.state.filteredVendors}
                            header={header}
                            size="small"
                            filters={this.state.filters}
                            filterDisplay="menu"
                            paginator={true}
                            rows={100}
                            emptyMessage="No vendors found."
                            sortField="VendorName"
                            sortOrder={1} //-1 = desc, 1 = asc
                            removableSort
                            scrollHeight="flex"
                            scrollable
                            dataKey="VendorNumber"
                            loading={this.state.loading}
                            loadingIcon="pi pi-spinner"
                        >
                                <Column field="VendorName" header="Name" sortable body={this.vendorNameBodyTemplate} />
                            <Column header="Categories" body={this.categoryBodyTemplate} />
                            <Column header="Regions" body={this.regionBodyTemplate} />
                        </DataTable>
                    </div>
                </div>
            </div>
        </div>
        );
    }
}